import "./Container.css";import e from"react";import a from"../../utils/classnames.js";const s=({children:s,className:t,...r})=>e.createElement("div",{className:a("perxis-auto-container",t),...r},s);export{s as default};
//# sourceMappingURL=Container.js.map
